import { render, staticRenderFns } from "./MisDocumentos.vue?vue&type=template&id=0b7d8883&"
import script from "./MisDocumentos.vue?vue&type=script&lang=js&"
export * from "./MisDocumentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports